import Vue from 'vue'
import { isTokenExpired } from '../../auth0/jwtHelper'

import profile from './profile'
import _ from 'lodash/lodash.min.js'
import loggingService from '../../services/util/loggingService'
import userService from '../../services/userService'

var isDebug = false

const state = {
    accessToken: null,
    authenticated: false,
    authResult: null,
    shpoUserDto: null
}

const actions = {
    authenticated ({dispatch, commit}, authResult) {
        loggingService.log(isDebug, 'auth', 'auth.authenticated - ' + state.authenticated)
        //authResult is not being passed properly, grabbing authResult from localStorage instead
        authResult = JSON.parse(localStorage.getItem('authResult'))
        commit('setAuthResult', authResult)
        commit('setAccessToken', authResult.accessToken)

        return new Promise((resolve, reject) => {
            var profilePromise = dispatch('shpoProfile/getProfile').then(value => {
                loggingService.log(isDebug, 'auth', 'auth.authenticated.dispatch.profile.getProfile.then')
            }, err => {
                reject(err)
            })

            var shpoUserPromise = userService.getCurrentShpoUserDto(Vue.prototype.$http).then(function (response) {
                loggingService.log(isDebug, 'auth', 'auth.userService.GetCurrentShpoUserDto')
                commit('setShpoUserDto', response.data)
            }, err => {
                reject(err)
            })

            Promise.all([ profilePromise, shpoUserPromise ]).then(results => {
                loggingService.log(isDebug, 'auth', 'authenticated - post promises')
                resolve(results)
                dispatch('verifyAuth')
                loggingService.log(isDebug, 'auth', 'auth.authenticated - post promises - ' + state.authenticated)
            }, err => {
                reject(err)
            })
        })
    },
    logout ({dispatch, commit}) {
        commit('setAccessToken', null)
        commit('setAuthResult', null)
        commit('shpoProfile/setProfile', {})

        dispatch('verifyAuth')
    },
    verifyAuth ({state, commit}) {
        if (_.isEmpty(state.authResult.idToken)) {
            commit('setAuth', false)
        } else {
            const tokenExpired = isTokenExpired(state.authResult.idToken)
            commit('setAuth', !tokenExpired)
        }
        loggingService.log(isDebug, 'auth', 'auth.verifyAuth - ' + state.authenticated)
    }
}

const mutations = {
    setAccessToken (state, token) {
        state.accessToken = token
    },
    setAuth (state, value) {
        state.authenticated = value
    },
    setAuthResult (state, value) {
        state.authResult = value
    },
    setShpoUserDto (state, value) {
        state.shpoUserDto = value
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        shpoProfile: profile
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js